import { Injectable } from '@angular/core';
import { LanguageEntryValue } from '@osos/shared/api';
import { LanguagePresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { LanguageParserV1Service } from '../../parsers/language-parser/language-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class LanguageFactoryService extends FactoryBase<
  LanguageEntryValue,
  LanguagePresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: LanguageParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  override createPresenterModel(
    model: LanguageEntryValue,
  ): LanguagePresenterModel {
    const parser = this.getParser(LanguageEntryValue, LanguagePresenterModel);
    const result = parser.getPresenterModel(model);
    return result;
  }
  override createDataModel(
    presenter: LanguagePresenterModel,
  ): LanguageEntryValue {
    const parser = this.getParser(LanguageEntryValue, LanguagePresenterModel);
    const result = parser.getDataModel(presenter);
    return result;
  }
}
